import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";

/** Tras analizar el periodo: el usuario elige el día concreto de la(s) ruta(s) y el alcance. Nunca se genera una ruta "multi-día". */
export default function DiaRutaSelector({ f, setF, resumen, onGenerar }) {
  const per = resumen?.periodo;
  if (!per) return null;
  const fechaRuta = f.fecha_ruta || per.inicio;
  const nDia = (resumen.por_dia || []).find(([d]) => d === fechaRuta)?.[1] || 0;
  const extra = (f.incluir_atrasados ? resumen.atrasados : 0) + (f.incluir_sin_fecha ? resumen.sin_fecha : 0);
  return (
    <div className="bg-zinc-900/50 border border-amber-500/30 rounded-xl p-4" data-testid="dia-ruta-selector">
      <div className="flex items-center gap-2 mb-3 text-[11px] uppercase tracking-wider text-amber-300 font-semibold"><CalendarDays className="w-3.5 h-3.5" /> Generar rutas para un día</div>
      <div className="grid grid-cols-1 md:grid-cols-[180px_1fr_auto] gap-3 items-end">
        <div>
          <Label className="text-[10px] text-zinc-500">Fecha de la(s) ruta(s)</Label>
          <Input type="date" value={fechaRuta} min={per.inicio} max={per.fin} data-testid="fecha-ruta" className="bg-zinc-950 border-zinc-800 h-9 text-sm"
            onChange={(e) => setF((p) => ({ ...p, fecha_ruta: e.target.value }))} />
        </div>
        <div className="text-[11px] space-y-1.5">
          <div className="flex flex-wrap gap-1" data-testid="por-dia-chips">
            {(resumen.por_dia || []).map(([d, n]) => (
              <button key={d} type="button" onClick={() => setF((p) => ({ ...p, fecha_ruta: d }))} data-testid={`dia-chip-${d}`}
                className={`px-2 py-0.5 rounded border font-mono ${d === fechaRuta ? "bg-amber-500/20 border-amber-500/60 text-amber-100" : "bg-zinc-950/60 border-zinc-800 text-zinc-400 hover:border-zinc-600"}`}>
                {d.slice(5)} <span className="opacity-70">·{n}</span>
              </button>
            ))}
            {!resumen.por_dia?.length && <span className="text-zinc-500 italic">Ningún trabajo con fecha dentro del periodo</span>}
          </div>
          <div className="flex flex-wrap gap-3">
            <label className="inline-flex items-center gap-1.5 text-zinc-300 cursor-pointer">
              <input type="radio" name="alcance" checked={f.alcance === "periodo"} onChange={() => setF((p) => ({ ...p, alcance: "periodo" }))} data-testid="alcance-periodo" />
              Todo el periodo <span className="text-zinc-500">({resumen.candidatos} trabajos)</span>
            </label>
            <label className="inline-flex items-center gap-1.5 text-zinc-300 cursor-pointer">
              <input type="radio" name="alcance" checked={f.alcance === "dia"} onChange={() => setF((p) => ({ ...p, alcance: "dia" }))} data-testid="alcance-dia" />
              Sólo trabajos del {fechaRuta} <span className="text-zinc-500">({nDia}{extra ? ` + ${extra} atrasados/sin fecha` : ""})</span>
            </label>
          </div>
          <div className="text-[10px] text-zinc-500">Las líneas con fecha fija distinta al día elegido se marcan en la tarjeta; el planificador no las mueve de día por conveniencia geográfica.</div>
        </div>
        <Button onClick={onGenerar} data-testid="generar-reparto-btn" className="bg-amber-500 hover:bg-amber-400 text-zinc-900 font-bold h-9">✨ Generar sugerencia</Button>
      </div>
    </div>
  );
}
